var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8465 8.18192C33.869 8.5074 33.869 8.83288 33.869 9.16136C33.869 19.1702 26.2494 30.7135 12.3168 30.7135V30.7075C8.20108 30.7135 4.17084 29.5346 0.706055 27.3117C1.30452 27.3837 1.90598 27.4197 2.50894 27.4212C5.91973 27.4242 9.23302 26.2798 11.9163 24.1724C8.67505 24.1109 5.83273 21.9976 4.83979 18.9122C5.97522 19.1312 7.14515 19.0862 8.25958 18.7818C4.7258 18.0678 2.18346 14.963 2.18346 11.3572C2.18346 11.3242 2.18346 11.2927 2.18346 11.2612C3.2364 11.8477 4.41532 12.1732 5.62124 12.2092C2.29295 9.98481 1.26702 5.55709 3.27689 2.09531C7.12265 6.82751 12.7968 9.70433 18.8879 10.0088C18.2774 7.37797 19.1114 4.62115 21.0793 2.77176C24.1301 -0.0960544 28.9283 0.0509364 31.7961 3.10024C33.4925 2.76577 35.1184 2.1433 36.6063 1.26136C36.0408 3.01475 34.8574 4.50416 33.2765 5.4506C34.7779 5.27361 36.2448 4.87163 37.6262 4.25817C36.6093 5.78207 35.3284 7.10949 33.8465 8.18192Z",
    fill: "#F9C7C4",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b58714c0dec5cdb44d2dc5c2f1de6fe9.svg";
export { ForwardRef as ReactComponent };